export default __webpack_public_path__ + "static/media/mobile_home.d33ea2cc.png";